import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { TreasurehuntService } from 'src/app/services/treasureHunt/treasurehunt.service';
import { FUN, WORK, NON_BOG_USER } from '../avatar-selection/avatars_contants';

@Component({
    selector: 'team-creation-success',
    templateUrl: './team-creation-success.html',
    styleUrls: ['./team-creation-success.scss'],
    standalone: false
})

export class TeamCreationSuccess extends BaseInjectorService implements OnInit {
  @Input() addedMembers: any = []
  @Input() huntColor : any;
  @Input() message : any = "";
   

  constructor(private modalCtrl:ModalController, private appService: AppService,public treasurehuntService:TreasurehuntService) {
    super()
   }

  ngOnInit() {
  }

  dismiss(){
    this.modalCtrl.dismiss();
  }


}
